import { AxiosError } from 'axios';

import { ApiError } from './customErrors';

export const makeApiError = (error: unknown): ApiError | unknown => {
  if (error instanceof AxiosError) {
    const errorMessage = error.message;
    const statusCode = error.response?.status;
    return new ApiError(errorMessage, statusCode);
  }

  return error;
};
